export default __webpack_public_path__ + "static/media/menu_5_price.b9cc07fd.jpg";